import { Feature, FeatureCollection, Point } from 'geojson';
import maplibregl from 'maplibre-gl';
import { useCallback, useEffect } from 'react';

import { selectionDotLayer } from '@/mapbox-layers/selections';

import { AcresFeature } from '../../models/features';
import centroid from '../../utils/centroid';
import getGeoJSONSource from '../../utils/getGeoJSONSource';
import Logger from '../../utils/logger';

/**
 * Will update the selections dot layer with the all of the current features
 * @param map
 * @param allFeatures
 */
const useSelectionCentroid = (
  map: maplibregl.Map | undefined,
  allFeatures: AcresFeature[]
) => {
  const setCentroids = useCallback(() => {
    try {
      if (!map) return;

      const allFeatureCentroids: Feature<Point>[] = [];

      allFeatures.forEach((feature) => {
        const center = centroid(
          feature.geometry,
          feature.id,
          feature.properties
        );

        if (center) {
          allFeatureCentroids.push(center);
        }
      });
      const featureCollection: FeatureCollection<Point> = {
        features: allFeatureCentroids,
        type: 'FeatureCollection',
      };

      const src = getGeoJSONSource(map, selectionDotLayer.id);

      src?.setData(featureCollection);
    } catch (err) {
      Logger.error(err);
    }
  }, [allFeatures, map]);

  useEffect(() => {
    if (!map) return;

    map.on('load', setCentroids);
  }, [map, setCentroids]);

  useEffect(() => {
    setCentroids();
  }, [setCentroids]);
};

export default useSelectionCentroid;
